
import CollapsibleExample from "../../components/Navbar";
import Booking from "../booking";
import Contact from "../contacts";
import Equipment from "../Equipment";
import Home from "../home";
import Portfolio from "../portfolio";
import Studio from "../studio";
import Team from "../team";
import "./landing.css";

const LandingPage = () => {


  return (
    <>
      <CollapsibleExample />
      <Home />
      <div className="App">
        <Booking />
        <Studio />
        <Team />
        <Equipment />
        <Portfolio />
        <Contact />
      </div>
    </>
  );
};

export default LandingPage;
